// Include custom styles.
import './styles.scss';

document.addEventListener('DOMContentLoaded', function () {
  console.log("Init complete.");
});
